import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import apiManagerUser from 'api/manager-users';
import OtpComponent from 'components/OTPVMP';
import ChangeEmail from 'components/common/ChangeEmail';
import ChangeUserp from 'components/common/ChangePassWord';
import VerifyEmail from 'components/common/VerifyEmail';
import moment from 'moment';
import { ERROR } from 'pages/authentication/components/constant';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setCloseModal } from 'store/modal/modalSlice';
import { setExpireTimeOTP } from 'store/user/accountInfo';
import { setUserInfo } from 'store/user/userInfoSlice';
import { toastError, toastSuccess } from 'utils/helpers';
import './OtpDialog.css';
import { COMPONENT_RENDER } from 'constants/common';
import { TOAST_DEFAULT } from 'constants/toast';
import { IconClose } from 'assets/icons';

export default function OtpDialog({ onSubmitVerifyOtp, pageSentOtp, title, componentRender = 0, checkClose, closeModal = false, passUser = "" }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const emailAccount = useSelector((state) => state.accountInfo.email);
    const expireTimeOTP = useSelector((state) => state.accountInfo.timeExpire);
    const [timerValue, setTimerValue] = useState(0);
    const interval = useRef(null);
    const [otp, setOtp] = useState('');
    const userInfo = useSelector((state) => state.userInfo.userInfo);
    const [maxEnterWrongOtp, setMaxEnterWrongOtp] = useState(0);
    const DaysConvertToSecond = 30 * 24 * 60 * 60;

    const sendOTP = (email, page) => {
        if (pageSentOtp === "profile-mail") {
            const username = localStorage.getItem('userName');
            return apiManagerUser.sendOTP(email, page, passUser, username);
        }else if(pageSentOtp === "register"){
            return apiManagerUser.sendOTP(email, page, undefined, undefined, [1, 1, 1, 0, 0, 0]);
        }
        return apiManagerUser.sendOTP(email, page, undefined, undefined);
    };

    const verifyOTP = (email, code, page) => {
        return apiManagerUser.verifyOTP(email, page, code);
    }

    const updateUser = (data) => {
        return apiManagerUser.updateUser(data);
    };

    const handleClose = () => {
        clearInterval(interval.current);
        setOtp('');
        dispatch(setCloseModal());
        if ((userInfo?.verifyMail && !userInfo?.timeMustVerifyMail)) {
            const username = userInfo?.username;
            const timeMustVerifyMail = parseInt(moment().unix());
            updateUser({ username, timeMustVerifyMail })
                .then(r => {

                })
                .catch(error => {
                    if (!localStorage.getItem(`timeVerifyEmail_${username}`)) {
                        localStorage.setItem(`timeVerifyEmail_${username}`, moment().unix())
                    }
                })
        }
    };

    const handleResendOtp = () => {
        setMaxEnterWrongOtp(0);
        if (localStorage?.getItem('limitTimeVerifyOtp')) {
            localStorage.removeItem('limitTimeVerifyOtp')
        }

        sendOTP(emailAccount, pageSentOtp)
            .then((r) => {
                toastSuccess(t('toast.sendOTPSuccess'));
                clearInterval(interval.current);
                dispatch(setExpireTimeOTP(r.timeExpire));
                setOtp('');
            })
            .catch((error) => {
                setOtp('');
                if (error?.response?.data?.detail === ERROR.MAX_FORGOT_ACCOUNT) {
                    toastError(t('auth.ERROR.MAX_FORGOT_ACCOUNT'));
                } else if (error?.response?.data?.detail === ERROR.MAX_FORGOT_DEVICE) {
                    toastError(t('auth.ERROR.MAX_FORGOT_DEVICE'));
                } else if (error?.response?.data?.detail === ERROR.NO_EMAIL) {
                    toastError(t('auth.ERROR.NO_EMAIL'));
                } else toastError(TOAST_DEFAULT.ERROR);
            });
    };

    const handleSubmitVerifyOtp = () => {
        let beforeEmailAccount = userInfo?.email;
        let limitTimeVerifyOtp = localStorage?.getItem('limitTimeVerifyOtp');
        if (maxEnterWrongOtp < 5 && (limitTimeVerifyOtp ? (moment().unix() - parseInt(limitTimeVerifyOtp) <= 600) : (true))) {
            verifyOTP(emailAccount, otp, pageSentOtp)
                .then(res => {
                    dispatch(setCloseModal())
                    onSubmitVerifyOtp(emailAccount, beforeEmailAccount, otp);
                    setMaxEnterWrongOtp(0);
                    if (limitTimeVerifyOtp) {
                        localStorage.removeItem('limitTimeVerifyOtp')
                    }
                    dispatch(setUserInfo({
                        ...userInfo,
                        verifyMail: ''
                    }))
                })
                .catch(error => {
                    if (error.response.data.data === "SSO FAILED") {
                        toastError(t('toast.invalidOtp'));
                        setMaxEnterWrongOtp(prev => prev += 1);
                    };
                    if (error.response.data.data === "OTP used") toastError(t('toast.usedOtp'));
                    if (error.response.data.data === "OTP max retry") toastError(t('toast.maxTryOtp'));
                })
        } else {
            toastError(t('toast.maxVerifyOtp'));
            if (!limitTimeVerifyOtp) {
                localStorage.setItem('limitTimeVerifyOtp', moment().unix())
            } else {
                if (moment().unix() - parseInt(limitTimeVerifyOtp) > 600) {
                    localStorage.removeItem('limitTimeVerifyOtp');
                    setMaxEnterWrongOtp(0)
                }
            }
        }
    }

    const getLocalizedDurationFormatter = (duration) => {
        if (duration <= 0) {
            return '00:00';
        }

        return moment.unix(duration).format('mm:ss');
    }

    const setStateFromUTC = (currentTimeUTC, expireTimeUTC) => {
        if (!currentTimeUTC || !expireTimeUTC) {
            return;
        }
        if (expireTimeUTC < currentTimeUTC) {
            setTimerValue('00:00');
            return;
        }
        const durationUTC = expireTimeUTC - currentTimeUTC;
        const localizedTime = getLocalizedDurationFormatter(durationUTC);
        setTimerValue(localizedTime);
    };

    const startTimer = () => {
        if (interval.current) {
            clearInterval(interval.current);
            interval.current = '';
        }
        setStateFromUTC(moment().unix(), expireTimeOTP);

        interval.current = setInterval(() => {
            setStateFromUTC(moment().unix(), expireTimeOTP);
        }, 1000);
    };

    useEffect(() => {
        if (expireTimeOTP) {
            startTimer();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [expireTimeOTP]);

    useEffect(() => {
        return () => {
            clearInterval(interval.current);
            // dispatch(setNullAccountInfo());
            setOtp('');
            if (localStorage?.getItem('limitTimeVerifyOtp')) {
                localStorage.removeItem('limitTimeVerifyOtp')
            }
        };
    }, [])


    return (
        <div className="verify-otp-dialog">
            <div className="modal-wrapper" style={{ borderRadius: '20px' }} >
                {(checkClose && ((moment().unix() - parseInt(userInfo?.timeMustVerifyMail) > parseInt(DaysConvertToSecond)) || (moment().unix() - parseInt(localStorage.getItem(`timeVerifyEmail_${userInfo?.username}`))) > parseInt(DaysConvertToSecond)))
                    ?
                    <></>
                    :
                    <IconButton
                        aria-label="close"
                        tabIndex={0}
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <IconClose />
                    </IconButton>
                }
                <DialogContent dividers sx={{ width: 'auto !important', maxWidth: { xl: componentRender === COMPONENT_RENDER.CHANGE_EMAIL ? '630px' : '500px' } }}>
                    {
                        componentRender === COMPONENT_RENDER.OTP
                            ?
                            <OtpComponent title={title} otp={otp} setOtp={setOtp} onSubmit={handleSubmitVerifyOtp} timerValue={timerValue} emailAccount={emailAccount} resendOtp={handleResendOtp} />
                            :
                            (componentRender === COMPONENT_RENDER.CHANGE_PASSWORD
                                ?
                                <ChangeUserp />
                                :
                                (
                                    componentRender === COMPONENT_RENDER.VERIFY_EMAIL ?
                                        <VerifyEmail checkClose={checkClose} />
                                        :
                                        <ChangeEmail closeModal={closeModal} checkClose={checkClose} beforeEmailAccount={userInfo?.email} emailAccount={emailAccount} />
                                )
                            )
                    }
                </DialogContent>
            </div>
        </div>
    );
}
